import Collapse from "bootstrap/js/dist/collapse";
import Tab from "bootstrap/js/dist/tab";
import Modal from "bootstrap/js/dist/modal";
import hcOffcanvasNav from "hc-offcanvas-nav";

import AOS from "aos";
import "@dotlottie/player-component";
import {
  lazyloadVideoElement,
  lazyloadiFrameElement,
  backgroundImageLazyLoad,
  insPanelCollapse,
} from "./utilities/lazyload";
import {
  navigation,
  bodyOverlay,
  navigationFunctions,
  opacityOnScroll,
  toggleHeaderSearch,
} from "./components/nav";
import { contactBar } from "./components/contactBar";
import { priorityTabs } from "./components/priorityTabs";
import {
  initSwiper,
  homepageStory,
  storySlider,
  paginationResetSlides,
} from "./components/sliders";
import { initPostFilters } from "./components/filters";
import { initPartnerMap, initlocationsMap } from "./components/partnerMap";
import googleMaps from "./components/map";
import desktopNav from "./components/desktopNav";
import { contactUs } from "./components/contactUs";
import initDownloadsPage from "./pages/downloads-page";
import { initDericSearch } from "./components/dericSearch";
const breakpoint = window.innerWidth;

// 25/10

$(function () {
  AOS.init();
  // Utilities
  backgroundImageLazyLoad();
  lazyloadiFrameElement();
  lazyloadVideoElement();

  // Navigation
  navigationFunctions(navigation);
  bodyOverlay();
  toggleHeaderSearch();

  // Componenets
  contactBar();

  //Sliders
  initSwiper();

  // Google Maps
  googleMaps();

  desktopNav();
  opacityOnScroll();

  priorityTabs();

  // filters
  initPostFilters();

  contactUs();

  initDownloadsPage();

  initDericSearch();

  insPanelCollapse();

  initPartnerMap();

});
